import { IconHeart, IconThumbDown, IconBookmark, IconMessageCircle, IconSend } from '@tabler/icons-react';
import { IconButton } from '@/components/IconButton';
import { compact } from '@/lib/format';
import type { ContentCard } from '@/api/types';

interface Props {
  card: ContentCard;
  onLike: () => void;
  onDislike: () => void;
  onBookmark: () => void;
  onComments: () => void;
  onShare: () => void;
}

export function CardCounters({ card, onLike, onDislike, onBookmark, onComments, onShare }: Props) {
  return (
    <div className="flex items-center justify-center px-2 gap-4">
      <IconButton onClick={onLike} active={card.user_actions.liked} label={compact(card.stats.likes)}>
        <IconHeart size={22} stroke={card.user_actions.liked ? 0 : 2} fill={card.user_actions.liked ? 'currentColor' : 'none'} />
      </IconButton>
      <IconButton onClick={onDislike} active={card.user_actions.disliked} label={compact(card.stats.dislikes)}>
        <IconThumbDown size={22} stroke={card.user_actions.disliked ? 0 : 2} fill={card.user_actions.disliked ? 'currentColor' : 'none'} />
      </IconButton>
      <IconButton onClick={onBookmark} active={card.user_actions.bookmarked} label={compact(card.stats.bookmarks)}>
        <IconBookmark size={22} stroke={card.user_actions.bookmarked ? 0 : 2} fill={card.user_actions.bookmarked ? 'currentColor' : 'none'} />
      </IconButton>
      <IconButton onClick={onComments} label={compact(card.stats.comments)}>
        <IconMessageCircle size={22} stroke={2} />
      </IconButton>
      <IconButton onClick={onShare} label={compact(card.stats.shares)}>
        <IconSend size={22} stroke={2} />
      </IconButton>
    </div>
  );
}
